import React, { useState, useEffect } from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddDocument(props) {
  return(
    <PostAdd 
      targetVid={"document_categories"}
      addPostEndpoint={apiEndpoints.documents}
      editRoute={"/documents/edit"}
      entityType={"document"}
      pageTitle={"Create a document post"}
      returnRoute={"/documents-creator"}
      onlySummary={true}
    />
  )
}
